import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import GoogleBigQueryWriterForm from '../forms/google-big-query-writer-form';
import { googleBigQueryWriterValidationSchema } from '../schema/googleBigQueryWriter.js';

export default function GoogleBigQueryWriterNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Google BigQuery Writer Node Details',
        altText: 'Google BigQuery Writer Node',
        defaultLabel: 'Google BigQuery Writer Node',
      }}
    >
      <CommonNode
        FormComponent={GoogleBigQueryWriterForm}
        schemaResolver={googleBigQueryWriterValidationSchema}
      />
    </NodeProvider>
  );
}
